import styled, { css, keyframes } from "styled-components";
import {
  AiOutlineCheckCircle,
  AiOutlineCloseCircle,
  AiOutlineLoading,
} from "react-icons/ai";

import { StyledStatusIconProps } from "./types";

const rotate = keyframes`
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
`;

export const StatusIcon = styled.div.attrs<StyledStatusIconProps>(
  ({ $isValid, $isLoading }) => ({
    // eslint-disable-next-line no-nested-ternary
    as: $isLoading
      ? AiOutlineLoading
      : $isValid
      ? AiOutlineCheckCircle
      : AiOutlineCloseCircle,
  })
)<StyledStatusIconProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 5rem;
  color: ${({ theme, $isValid }) =>
    // eslint-disable-next-line no-nested-ternary
    $isValid === true
      ? theme.colors.success
      : $isValid === false
      ? theme.colors.error
      : theme.colors.deepSeaDive} !important;
  display: ${({ $isValid, $isLoading }) =>
    $isValid === undefined && !$isLoading ? "none" : "block"};

  ${({ $isLoading }) =>
    $isLoading &&
    css`
      animation: ${rotate} 2s infinite linear;
    `}
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-rows: 1fr auto 1fr;
  height: 100%;
`;

export const QrScannerContainer = styled.div<StyledStatusIconProps>`
  position: relative;
  width: 100%;
  grid-row: 2;

  svg {
    path {
      stroke: ${({ theme, $isValid }) =>
        // eslint-disable-next-line no-nested-ternary
        $isValid === true
          ? theme.colors.success
          : $isValid === false
          ? theme.colors.error
          : theme.colors.deepSeaDive} !important;
    }
  }
`;

export const StatusMessage = styled.div`
  grid-row: 3;
  text-align: center;
  overflow: auto;
`;

export const StatusMessageHeading = styled.div`
  font-size: 2rem;
  font-weight: 600;
`;

export const StatusMessageValue = styled.span<StyledStatusIconProps>`
  color: ${({ theme, $isValid }) =>
    $isValid ? theme.colors.success : theme.colors.error};
  margin-left: 0.5rem;
`;

export const Description = styled.div``;

export const DescriptionLabel = styled.label`
  font-weight: 600;
  margin-right: 0.5rem;
`;
